import logoBoa from 'img/logo.svg'


export const mockQuoteHeader = {
  logo: {
    url: logoBoa,
  },
  phone_de: '0800 33 55 88',
  phone_fr: '0800 31 03 20',
  languages_menu: [
    { title: 'DE', value: 'de' },
    { title: 'FR', value: 'fr' },
  ],
}
